import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/** An empty screen is an invitation to act, so it always names the next move. */
export function Empty({
  title,
  body,
  action,
  className,
}: {
  title: string;
  body?: ReactNode;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('flex flex-col items-start gap-2 px-3 py-10 text-left', className)}>
      <div className="mb-1 h-px w-8 bg-rule-strong" aria-hidden />
      <p className="text-sm font-medium text-ink">{title}</p>
      {body ? <p className="max-w-prose text-sm text-ink-2">{body}</p> : null}
      {action ? <div className="pt-1">{action}</div> : null}
    </div>
  );
}
